import toBuffer from 'it-to-buffer'
import { CustomProgressEvent } from 'progress-events'
import { NotFoundError } from '../errors.js'
import extractDataFromBlock from '../utils/extract-data-from-block.js'
import validateOffsetAndLength from '../utils/validate-offset-and-length.js'
import type { ExporterOptions, Resolver, ExportProgress } from '../index.js'

const rawContent = (node: Uint8Array): ((options?: ExporterOptions) => AsyncGenerator<Uint8Array, void, undefined>) => {
  async function * contentGenerator (options: ExporterOptions = {}): AsyncGenerator<Uint8Array, void, undefined> {
    const {
      start,
      end
    } = validateOffsetAndLength(node.length, options.offset, options.length)

    const buf = extractDataFromBlock(node, 0n, start, end)

    options.onProgress?.(new CustomProgressEvent<ExportProgress>('unixfs:exporter:progress:raw', {
      bytesRead: BigInt(buf.byteLength),
      totalBytes: end - start,
      fileSize: BigInt(node.byteLength)
    }))

    yield buf
  }

  return contentGenerator
}

const resolve: Resolver = async (cid, name, path, toResolve, resolve, depth, blockstore, options) => {
  if (toResolve.length > 0) {
    throw new NotFoundError(`No link named ${path} found in raw node ${cid}`)
  }

  const block = await toBuffer(blockstore.get(cid, options))

  return {
    entry: {
      type: 'raw',
      name,
      path,
      cid,
      content: rawContent(block),
      depth,
      size: BigInt(block.length),
      node: block
    }
  }
}

export default resolve
